import { Box as MuiBox, Button as MuiButton } from "@mui/material";

const formButtonStyles = {
  buttonBox: {
    width: "120px",
  },
};

export const FormButton = (props) => {
  return (
    <MuiBox sx={formButtonStyles.buttonBox}>
      <MuiButton fullWidth color="primary" variant={props.variant} {...props}>
        {props.name}
      </MuiButton>
    </MuiBox>
  );
};
